import { createSlice } from "@reduxjs/toolkit";
import { StudentResponseDto } from "../../shared/dtos/student/StudentResponseDto";
import { StudentSummaryDto } from "../../shared/dtos/student/StudentSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const studentSlice = createSlice({
  name: "student",
  initialState: getInitialCrudState<StudentResponseDto, StudentSummaryDto>(),
  reducers: {
    ...generateCrudReducers<StudentResponseDto, StudentSummaryDto>(),
  },
});

export const studentActions = studentSlice.actions;
export default studentSlice.reducer;
